<template>
    <section class="section-base-modal" @click="closeModal">
        <div class="base-modal" title="clique em qualquer lugar na tela para fechar este aviso.">
            <span class="box-titulo">AVISO IMPORTANTE</span>
            <div class="div-aviso">
                <figure>
                    <img src="https://serrano-desenvolvimento.s3.sa-east-1.amazonaws.com/public/cadastro/layout/modelo-documento-aberto.jpg" alt="modelo-documento-aberto" title="modelo de documento aberto RG/CNH etc (frente e verso)">
                </figure>
                <p>Para obter os melhores resultados na extração de texto <strong>(OCR)</strong>, certifique-se de
                    posicionar o documento
                    totalmente aberto,
                    exibindo frente e verso. Isso ajuda a <strong>capturar</strong> todas as
                    <strong>informações</strong> de forma mais precisa e <strong>completa</strong>,
                    evitando possíveis cortes ou distorções no texto detectado.
                </p>
            </div>
            <button @click="closeModal" title="clique aqui para fechar">fechar</button>
            <span class="box-footer-base">
                <img src="@/assets/img/bases/Vector.png" alt="" class="img-vetor">
                <span class="box-footer-duvida"><a :href="link_ajuda" target="_blank">Dúvida? Posso ajudar</a></span>
            </span>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ModalValidadorDocumentos',
    data() {
        return {
            openModal: true
        };
    },
    methods: {
        closeModal() {
            this.$emit('fecharModal', false)
        },
    }
}
</script>

<style scoped>
.box-footer-base {
    display: flex;
    cursor: pointer;
    align-items: center;
    position: absolute;
    bottom: 2rem;
}

.box-footer-duvida {
    margin-left: 10px;
    font-size: 13px;
}

.section-base-modal {
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    position: fixed;
    background: #ffffff00;
    backdrop-filter: blur(2px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}

.base-modal {
    display: flex;
    max-width: 800px;
    width: 100%;
    background: var(--bd-primary);
    padding: 15px;
    border-radius: 12px;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.22);
    flex-direction: column;
    align-items: center;
}
.base-modal figure img {
    max-width: 280px;
}
.base-modal button {
    width: 300px;
    padding: 10px;
    border: none;
    background-color: red;
    color: #fff;
    border-radius: 24px;
    text-transform: uppercase;
    cursor: pointer;
}

.div-aviso {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    padding: 15px 0;
    justify-content: space-evenly;
}

.div-aviso p {
    animation: slideFromTop 1s ease forwards, fadeIn 2s ease forwards;
    color: #fff;
    font-weight: 200;
    line-height: 30px;
    padding: 0 15px;
    font-size: 16px;
    width: 53%;
    text-align: justify;
}

@media screen and (max-width: 768px) {
    .div-aviso {
        flex-wrap: wrap;
        justify-content: center;
    }
    .base-modal figure img {
        width: 200px;
    }
    .base-modal {
        width: 98%;
    }
    .box-footer-base {
        bottom: 10px;
    }
    .div-aviso p {
        width: 90%;
    }
}
</style>